<!--  -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-ctn-left">
                <el-button size="small" icon="el-icon-plus" class="search-btn btn-primary" @click="gotoEdit(3)" v-if="permission.add">{{ permission.add }}</el-button>
            </div>
            <div class="search-ctn-right">
                <div class="search-name">询价单号:</div>
                <el-input class="search-item" size="small" v-model.trim="searchData.ICode" v-filter-special-char="searchData.ICode" placeholder="询价单号"></el-input>
                <div class="search-name">创建时间:</div>
                <i class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
            </div>
        </div>
        <div class="table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column min-width="220px" prop="ICode" label="询价单号" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120px" prop="TotalQuantity" label="商品数量" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160px" prop="NeedTime" label="期限时间" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="160px" prop="QTime" label="报价时间" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120px" prop="Total" label="合计" show-overflow-tooltip></el-table-column>
                <el-table-column min-width="120px" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">{{ scope.row.State | stateHandle }}</template>
                </el-table-column>
                <el-table-column min-width="160px" prop="CreateTime" label="创建时间" show-overflow-tooltip></el-table-column>
                <el-table-column fixed="right" label="操作" :autoWidth="true">
                    <template slot-scope="scope">
                        <div class="ops-ctn">
                            <el-button title="查看" size="mini" type="text" @click="gotoEdit(1, scope.row)" v-if="permission.see">{{ permission.see }}</el-button>
                            <el-button v-if="scope.row.State == 0 && permission.edit" title="编辑" size="mini" type="text" @click="gotoEdit(2, scope.row)">{{
                                permission.edit
                            }}</el-button>
                            <el-button v-if="scope.row.State == 0 && permission.submit" title="提交询价" size="mini" type="text" @click="submitRfg(scope.row)">{{
                                permission.submit
                            }}</el-button>
                            <el-button
                                v-if="scope.row.State == 2 && !scope.row.IsTransform && permission.trans"
                                title="转为采购订单"
                                size="mini"
                                type="text"
                                @click="transOrder(scope.row)"
                                >{{ permission.trans }}</el-button
                            >
                            <el-button v-if="scope.row.State == 0 && permission.del" title="删除" size="mini" type="text" @click="delRfg(scope.row)">{{
                                permission.del
                            }}</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
            <div class="dialog-content" v-if="timeVisible">
                <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import mixin from '@/mixins/mixin';
import timePicker from '@/components/common/timePicker';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    components: {
        timePicker,
        breadcrumb,
        elTableColumn
    },
    name: '',
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            userMsg: userMsg,
            timeVisible: false,
            dialogVisible: false,
            searchData: {
                EntpId: userMsg.EntpId,
                ICode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            tableData: [],
            tableDataLength: 0,
            permission: {}
        };
    },
    mounted() {
        this.getTableData();
        this.$util.setEnterEvent(this, this.$route.fullPath);
        this.permission = this.$util.getPermission('rfq');
    },
    watch: {
        NeedRefresh(value) {
            if (value.NeedRefresh) {
                this.getTableData();
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$route.query;
        }
    },
    filters: {
        stateHandle(value) {
            if (value == 0) {
                return '未提交';
            } else if (value == 1) {
                return '等待报价';
            } else if (value == 2) {
                return '已报价';
            }
        }
    },
    methods: {
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 转为订单
        transOrder(row) {
            this.$router.push(`./transToOrder?id=${row.InquiryBillId}`);
        },
        // 删除询价
        delRfg(row) {
            let that = this;
            this.$util.elConfirm({
                content: '确定要删除该询价单吗？',
                confirm() {
                    that.$util
                        .axiosPost({
                            url: '/api/InquiryOrder/DeleteInquiryOrder',
                            data: {
                                inquiryBillId: row.InquiryBillId,
                                userId: that.userMsg.EmployeeId
                            }
                        })
                        .then(() => {
                            that.searchData.page = 1;
                            that.getTableData();
                        });
                }
            });
        },
        // 提交询价
        submitRfg(row) {
            this.$util
                .axiosPost({
                    url: '/api/InquiryOrder/SubmitInquiryOrderReview',
                    data: {
                        inquiryBillId: row.InquiryBillId,
                        userId: this.userMsg.EmployeeId
                    }
                })
                .then(res => {
                    this.$util.successMsg('提交成功');
                    this.getTableData();
                });
        },
        resetSearch() {
            this.searchData = {
                EntpId: this.userMsg.EntpId,
                ICode: '',
                StartDate: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
        },
        getTableData() {
            this.$util
                .axiosGet({
                    url: '/api/InquiryOrder/GetInquiryOrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                });
        },
        gotoEdit(type, row) {
            let _id = row ? row.InquiryBillId : '';
            this.$router.push(`./rfqEdit?type=${type}&id=${_id}`);
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        }
    }
};
</script>
